import { SAVED_FILTERS_BY_VALUE, SavedFiltersIds, UNIQUE_SAVED_FILTERS } from '../../interfaces/filters';
import { Action, ISavedFilter } from './actions';

export interface ISavedFilters {
  items: ISavedFilter[];
  showAll: boolean;
}
export function savedFiltersReducer(state: ISavedFilters, action: Action): ISavedFilters {
  switch (action.type) {
    case 'AllSavedFiltersRemoved':
      return { ...state, items: [] };
    case 'SavedFilterAdded':
      return { ...state, items: sortFilters([...removeSavedFilter(state.items, action.payload), action.payload]) };
    case 'SavedFilterChanged':
      return { ...state, items: changeSavedFilter(state.items, action.payload) };
    case 'SavedFilterRemoved':
      return { ...state, items: sortFilters(removeSavedFilter(state.items, action.payload)) };
    case 'FitTagsInOneLineChanged':
      return { ...state, showAll: action.value };
    default:
      return state || {};
  }
}

function removeSavedFilter(arr: ISavedFilter[], savedFilter: ISavedFilter) {
  return arr.filter(({ id, name, value }) => {
    if (UNIQUE_SAVED_FILTERS.includes(id)) {
      return id !== savedFilter.id;
    } else if (typeof value === 'number' && SAVED_FILTERS_BY_VALUE.includes(id)) {
      return value !== savedFilter.value;
    } else {
      return name !== savedFilter.name;
    }
  });
}

const SAVED_FILTERS_SORTING: { [key: number]: number } = {
  [SavedFiltersIds.RoadDistance]: 26,
  [SavedFiltersIds.GroupedRoad]: 25,
  [SavedFiltersIds.Road]: 24,
  [SavedFiltersIds.StationDistance]: 23,
  [SavedFiltersIds.GroupedStation]: 22,
  [SavedFiltersIds.Station]: 21,
  [SavedFiltersIds.Location]: 20,
};

function sortFilters(arr: ISavedFilter[]) {
  const start = arr
    .filter(({ id }) => id in SAVED_FILTERS_SORTING)
    .sort((a, b) => {
      if (a.id === b.id) {
        return a.name.localeCompare(b.name);
      } else {
        return getSavedFiltersSorting(b) - getSavedFiltersSorting(a);
      }
    });
  const end = arr.filter(({ id }) => !(id in SAVED_FILTERS_SORTING));

  return start.concat(end);
}

function changeSavedFilter(arr: ISavedFilter[], value: ISavedFilter) {
  return arr.map(item => (item.id === value.id ? value : item));
}

function getSavedFiltersSorting({ id, value = 0 }: ISavedFilter) {
  const sorting = SAVED_FILTERS_SORTING[id] || id;

  if (id === SavedFiltersIds.Road && typeof value === 'number') {
    return sorting - value / 1e10;
  } else {
    return sorting;
  }
}
